import type { FC } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";
import { PatientRxSignInPage } from "@unauthenticated/signupSignin/scenes";

interface Props {
  patientAttributes: PatientAttributes;
  emailRegex: string;
  treatmentPlanTerm: string;
  additionalAttributes?: any;
  currentCountry: string;
  csuid: string;
  flippers: Flipper[];
  roleId: string;
  storeId: string;
  newSSOErrors?: string;
  e2e: boolean;
  analyticsAnonymousId: string;
}

const PatientRxSignIn: FC<Props> = ({
  patientAttributes,
  emailRegex,
  treatmentPlanTerm,
  additionalAttributes,
  currentCountry,
  csuid,
  flippers,
  roleId,
  storeId,
  newSSOErrors,
  e2e,
  analyticsAnonymousId,
}) => {
  return (
    <Providers
      emailRegex={emailRegex}
      treatmentPlanTerm={treatmentPlanTerm}
      currentCountry={currentCountry}
      flippers={flippers}
      e2e={e2e}
      analyticsAnonymousId={analyticsAnonymousId}
    >
      <ErrorBoundary {...{ flippers, csuid, roleId, storeId }}>
        <PatientRxSignInPage
          patientAttributes={patientAttributes}
          additionalAttributes={additionalAttributes}
          newSSOErrors={newSSOErrors}
        />
      </ErrorBoundary>
    </Providers>
  );
};

export { PatientRxSignIn };
